import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // Positioned with the CSS logical property `inset-inline-start`, which resolves against the
        // element's OWN computed direction. Tailwind's `rtl:` variant compiles to the ancestor
        // selector `[dir="rtl"] &` — since <html> is always dir="rtl" here, that selector wrongly
        // matched inside admin's nested dir="ltr" subtree and slid the thumb off the track.
        "pointer-events-none absolute top-0 block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-[inset-inline-start] start-0 data-[state=checked]:start-5"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
